var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "el-section" }, [
    _c("section", { staticClass: "el-section" }, [
      _c("div", { staticClass: "el-chunk" }, [
        _c("h2", { staticClass: "emd-text _size_page" }, [
          _vm._v(" " + _vm._s(_vm.$t("title")) + " "),
        ]),
      ]),
      _c("p", { staticClass: "el-chunk" }, [
        _vm._v(" " + _vm._s(_vm.$t("subtitle")) + " "),
      ]),
    ]),
    _vm.accountSummary
      ? _c("section", { staticClass: "el-section" }, [
          _c("div", { staticClass: "el-grid-list" }, [
            _c(
              "div",
              {
                staticClass:
                  "emd-container _type_card _content_spaced _footer_end eu-height_100",
                class: { "eu-bg_success": _vm.hasCheckoutEnabled },
              },
              [
                _c("div", { staticClass: "emd-container__content" }, [
                  _c("div", { staticClass: "eu-flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "eu-flex-item eu-basis_12 eu-basis_10_md",
                      },
                      [
                        _c("p", { staticClass: "emd-text _size_section" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("configurations.checkout")) +
                              " "
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "emd-container__footer" }, [
                  _c(
                    "p",
                    {
                      staticClass: "emd-text _type_label eu-pt_4",
                      class: {
                        _color_success: _vm.hasCheckoutEnabled,
                        _color_subtle: !_vm.hasCheckoutEnabled,
                      },
                    },
                    [
                      _vm.hasCheckoutEnabled
                        ? _c("span", [
                            _c("i", { staticClass: "uil uil-check" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("configurations.status.configured")
                                ) +
                                " "
                            ),
                          ])
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("configurations.status.notConfigured")
                              )
                            ),
                          ]),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "emd-container _type_card _content_spaced _footer_end eu-height_100",
                class: { "eu-bg_success": _vm.hasPaymentMethodsEnabled },
              },
              [
                _c("div", { staticClass: "emd-container__content" }, [
                  _c("div", { staticClass: "eu-flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "eu-flex-item eu-basis_12 eu-basis_10_md",
                      },
                      [
                        _c("p", { staticClass: "emd-text _size_section" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("configurations.paymentMethods")) +
                              " "
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "emd-container__footer" }, [
                  _c(
                    "p",
                    {
                      staticClass: "emd-text _type_label eu-pt_4",
                      class: {
                        _color_success: _vm.hasPaymentMethodsEnabled,
                        _color_subtle: !_vm.hasPaymentMethodsEnabled,
                      },
                    },
                    [
                      _vm.hasPaymentMethodsEnabled
                        ? _c("span", [
                            _c("i", { staticClass: "uil uil-check" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("configurations.status.configured")
                                ) +
                                " "
                            ),
                          ])
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("configurations.status.notConfigured")
                              )
                            ),
                          ]),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "emd-container _type_card _content_spaced _footer_end eu-height_100",
                class: { "eu-bg_success": _vm.hasOpenOrdersEnabled },
              },
              [
                _c("div", { staticClass: "emd-container__content" }, [
                  _c("div", { staticClass: "eu-flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "eu-flex-item eu-basis_12 eu-basis_10_md",
                      },
                      [
                        _c("p", { staticClass: "emd-text _size_section" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("configurations.createOrder")) +
                              " "
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "emd-container__footer" }, [
                  _c(
                    "p",
                    {
                      staticClass: "emd-text _type_label eu-pt_4",
                      class: {
                        _color_success: _vm.hasOpenOrdersEnabled,
                        _color_subtle: !_vm.hasOpenOrdersEnabled,
                      },
                    },
                    [
                      _vm.hasOpenOrdersEnabled
                        ? _c("span", [
                            _c("i", { staticClass: "uil uil-check" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("configurations.status.configured")
                                ) +
                                " "
                            ),
                          ])
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("configurations.status.notConfigured")
                              )
                            ),
                          ]),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
        ])
      : _vm._e(),
    _c("section", { staticClass: "el-section" }, [
      _vm.hasAccessToConfigureDash
        ? _c("div", { staticClass: "eu-align_right" }, [
            _c(
              "a",
              {
                staticClass: "emd-btn _color_primary",
                attrs: { href: _vm.urlDash },
              },
              [
                _c("i", { staticClass: "uil uil-external-link-alt" }),
                _vm._v(" " + _vm._s(_vm.$t("configurations.access")) + " "),
              ]
            ),
          ])
        : _c("p", [
            _vm._v(" " + _vm._s(_vm.$t("configurations.contactAdmin")) + " "),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }